export default['/home', '/home/pic']
